import React from 'react'

import moment from 'moment'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'

import { reportError } from 'utils/errorReporter'
import styles from '../styles'

const BuildPep = (props) => {
  const { pepData } = props
  const classes = styles()
  try {
    return pepData.is_pep ? (
      <div className={classes.expansibleContent}>
        <div>
          <strong>Tipo: </strong>
          {pepData.classification}
        </div>

        <div>
          <strong>Último Status: </strong>
          {pepData.last_pep_status
            ? pepData.last_pep_status
            : 'Não informado'}
        </div>

        <div>
          <strong>Início da Classificação: </strong>
          {
            pepData.start_date ?
            moment(pepData.start_date).format('DD/MM/YYYY') :
            'N/A'
          }
        </div>

        <div>
          <strong>Fim da Classificação: </strong>
          {
            pepData.end_date ?
            moment(pepData.start_date).format('DD/MM/YYYY') :
            'N/A'
          }
        </div>

        <strong>Motivo da Classificação:</strong>
        <ul>
          {addKeyToObjectsArray(pepData.reason.map(motivo => { return { text: motivo } })).map((motivo) => {
            return <li key={motivo.key}>{motivo.text}</li>
          })}
        </ul>
      </div>
    ) : (
      <div className={classes.expansibleContent}>
        <span>Candidato não é PEP.</span>
      </div>
    )
  } catch (err) {
    reportError(err)
    return (
      <div className={classes.errorCaptured}>
        <span>Ocorreu um erro ao tratar os dados</span>
      </div>
    )
  }
}

export default BuildPep
